"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = When;

function When(a) {
  var b = a.condition,
      c = a.failWith,
      d = a.children;
  return b ? d || null : c || null;
}